import { IMobileAppRootState } from "../../mobileAppCore/types/mobileAppState.t";
import { createSelector } from "reselect";
import { ILiteTradeAssetSymbol } from "../LiteTrade/types/liteTradeReducer.t";

const moduleSelector = (state: IMobileAppRootState) => state.alerts;

export const getIsAlertsInitedSelector = createSelector(
    moduleSelector, state => state.isInited,
);

export const getAlertsListSelector = createSelector(
    moduleSelector, state => state.alertsList,
);

export const makeSelectAlertsListBySymbol = (symbol: ILiteTradeAssetSymbol) => createSelector(
    getAlertsListSelector, alertsList => alertsList.filter(alert => alert.symbol === symbol),
);
